export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.608 2.099a1 1 0 011.058.12l5.959 4.765a1.002 1.002 0 01-.034 1.587l-4.678 3.43 4.678 3.428a1 1 0 01.034 1.588l-5.959 4.764a1 1 0 01-1.624-.78v-6.896L5.591 18.1l-1.182-1.614L10.53 12 4.41 7.513 5.59 5.9l5.452 3.995V3a1 1 0 01.566-.901zm1.434 16.82l3.313-2.65-3.313-2.428v5.078zm0-8.76l3.313-2.43-3.313-2.649v5.078z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};